import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AcompanhamentoService } from '@app/shared/services';
import { MensagemService } from '@app/shared/services/mensagem.service';

import { Loading, Segurado } from '@app/shared/models';

@Component({
  selector: 'app-modal-avaliar-atendimento',
  templateUrl: './modal-avaliar-atendimento.component.html',
  styleUrls: ['./modal-avaliar-atendimento.component.scss']
})
export class ModalAvaliarAtendimentoComponent implements OnInit {

  avaliacaoForm!: FormGroup;

  stars: number[] = [1, 2, 3, 4, 5];
  selectedValue: number = 0;
  isMouseover = true;

  carregar = new Loading();

  constructor(
    public dialogRef: MatDialogRef<ModalAvaliarAtendimentoComponent>,
    private formBuilder: FormBuilder,
    private mensagemService: MensagemService,
    private acompanhamentoService: AcompanhamentoService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Segurado
  ) { }

  ngOnInit(): void {
    this.avaliacaoForm = this.formBuilder.group({
      notaAvaliacao: [null],
    });
  }

  avaliarRequerimento() {
    this.avaliacaoForm.get('notaAvaliacao').setValue(this.selectedValue);
    this.acompanhamentoService.enviarAvaliacaoAtendimento(this.avaliacaoForm.value, this.carregar).subscribe(() => {
      this.mensagemService.avisoMensagemSucesso('Avaliação enviada com sucesso!');
      this.acompanhamentoService.setAvaliacao(true);
      this.dialogRef.close();
    })
  }

  countStar(star: number) {
    this.isMouseover = false;
    this.selectedValue = star;
  }

  addClass(star: number) {
    if (this.isMouseover) {
      this.selectedValue = star;
    }
  }

  removeClass() {
    if (this.isMouseover) {
      this.selectedValue = 0;
    }
  }

}
